export const companyName = "KDR";
export const patterns = {
  email: "^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$",
};
